<template lang="pug">
	div(:class="clase", :title="titulo", @click="haceClick()", :style="estilo") {{asiento.Numero}}
</template>

<script>
export default {
	props: ['asiento', 'cadena'],
	computed: {
		clase () {
			const clase = ['base']
			if (this.asiento.Etiqueta === 'A') {
				clase.push('asiento')
				if (this.asiento.Seleccionado) {
					clase.push('preseleccion')
				} else if (this.asiento.Ocupado) {
					clase.push('ocupado')
				}

				if (this.cadena) {
					const exp = new RegExp(this.cadena, 'ig')
					let coincide = false
					if (this.asiento.Datos) {
						coincide = (exp.test(this.asiento.Datos.Asistente.Nombre) || exp.test(this.asiento.Datos.Persona.Nombre))
					}

					if (!coincide) {
						clase.push('noCoincide')
					}
				}
			}

			return clase.join(' ')
		},
		titulo () {
			let cadena = 'Fila ' + this.asiento.Fila + ':' + this.asiento.Numero

			if (this.asiento.Datos === null) {
				return cadena
			}
			if (this.asiento.Datos.Asistente.Nombre) {
				cadena = cadena + '. ' + this.asiento.Datos.Asistente.Nombre
			}

			if (this.asiento.Datos.Persona.Nombre) {
				cadena = cadena + ' - ' + this.asiento.Datos.Persona.Nombre
			}

			return cadena
		},
		estilo () {
			const est = {}

			if (this.asiento.Etiqueta !== 'A') {
				return est
			}
			if (this.asiento.Seleccionado) {
				est.backgroundColor = 'orange'
				est.color = 'black'
			} else if (this.asiento.Ocupado) {
				est.backgroundColor = this.asiento.ColorFondo
				est.color = this.asiento.ColorLetra
			} else {
				est.backgroundColor = '#fdfdfd'
				est.border = '1px solid ' + this.asiento.ColorFondo
				est.color = '#333333'
			}
			return est
		}
	},
	methods: {
		haceClick () {
			this.$emit('pulsado', this.asiento)
		}
	}
}
</script>

<style scoped>
	.base {
		position: relative;
		display: inline-block;
		width: 20px;
		height: 20px;
		margin: 1px;
		box-sizing: border-box;
		text-align: center;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Old versions of Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
				user-select: none; /* Non-prefixed version, currently
									supported by Chrome, Opera and Firefox */
	}
	.asiento {
		background-color: #f9f9f9;
		border: 1px solid #e0e0e0;
		border-radius: 4px;
		cursor: pointer;
		color: #999999;
	}
	.asiento:hover {
		background-color: yellow !important;
		color: black;
	}
	/* .ocupado {
		background-color: #df0218;
		color: #e68d95;
	} */

	.preseleccion {
		background-color: #9672d5;
		color: white;
	}

	.noCoincide {
		opacity: 0.3;
	}
</style>


// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/editor/asiento.vue